import { gql } from '@apollo/client';

export const GET_ALL_FORM_RESPONSES_FOR_COMPANY_BY_DATE_RANGE = gql`
  query GetAllFormResponsesForCompanyByDateRange(
    $input: FormResponseForDateRangeInput!
  ) {
    allFormResponsesForCompanyByDateRange(input: $input) {
      id
      dateCompleted
      pages {
        answers
      }
      createdAt
      surveyId
      templateVersionId
      updatedAt
      employeeDepartmentWhenCreated
      employeeId
      companyId
    }
  }
`;

export const GET_FORM_RESPONSE_STATUS = gql`
  query GetFormResponseStatus($formId: ID!) {
    formResponseStatus(formId: $formId) {
      formId
      formTitle
      isAnonymous
      invitedCount
      respondedCount
      unattributedCount
      namesWithheld
      targetGroupCount
      allowsMultipleResponses
      deliveryTracked
      deliveryCounts {
        delivered
        problem
        pending
        unknown
      }
      responded {
        id
        employeeId
        firstName
        lastName
        emailAddress
        department
        dateCompleted
        responseCount
        deliveryStatus
      }
      notResponded {
        id
        employeeId
        firstName
        lastName
        emailAddress
        department
        dateCompleted
        responseCount
        deliveryStatus
      }
    }
  }
`;

export const GET_FORM_RESPONSES_FOR_CURRENT_USER_AND_COMPANY_NO_AUTH = gql`
  query GetFormResponsesNoAuth($input: FormResponseInput) {
    formResponsesNoAuth(input: $input) {
      id
      dateCompleted
      pages {
        answers
      }
      createdAt
      surveyId
      updatedAt
      employeeDepartmentWhenCreated
    }
  }
`;

export const GET_FORM_RESPONSE_BY_ID_NO_AUTH = gql`
  query GetFormResponseByIdNoAuth($id: ID!, $employeeId: String!, $companyId: String!) {
    formResponseByIdNoAuth(id: $id, employeeId: $employeeId, companyId: $companyId) {
      id
      dateCompleted
      pages {
        answers
      }
      createdAt
      surveyId
      updatedAt
      employeeDepartmentWhenCreated
      companyId
      employeeId
    }
  }
`;

export const GET_FORM_RESPONSE_BY_EMPLOYEE_ID_AND_COMPANY_ID = gql`
  query GetFormResponseByEmployeeIdAndCompanyId($input: FormResponseInput!) {
    formResponse(input: $input) {
      id
      dateCompleted
      pages {
        answers
      }
      createdAt
      surveyId
      updatedAt
      employeeDepartmentWhenCreated
    }
  }
`;

export const CREATE_FORM_RESPONSE_NO_AUTH = gql`
  mutation CreateFormResponseNoAuth($input: CreateFormResponseInput!) {
    createFormResponseNoAuth(input: $input) {
      id
      dateCompleted
      pages {
        answers
      }
      createdAt
      surveyId
      updatedAt
      employeeDepartmentWhenCreated
      companyId
      employeeId
    }
  }
`;

export const UPDATE_FORM_RESPONSE_NO_AUTH = gql`
  mutation UpdateFormResponseNoAuth(
    $id: ID!
    $input: CreateFormResponseInput!
  ) {
    updateFormResponseNoAuth(id: $id, input: $input) {
      id
      dateCompleted
      pages {
        answers
      }
      createdAt
      surveyId
      updatedAt
      employeeDepartmentWhenCreated
    }
  }
`;

export const DELETE_FORM_RESPONSE_NO_AUTH = gql`
  mutation DeleteFormResponseNoAuth($id: ID!) {
    deleteFormResponseNoAuth(id: $id)
  }
`;

/** The response a private link from a manager's text alert opens. Public: the token is the key. */
export const GET_SHARED_RESPONSE = gql`
  query GetSharedResponse($token: String!) {
    sharedResponse(token: $token) {
      companyName
      formTitle
      respondent
      submittedAt
      expiresAt
      answers {
        number
        question
        answer
      }
    }
  }
`;
